import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import MonthYearPicker from '@/components/selector/month-year-picker/month-year-picker';
import ChartCardComponent from './chart-card/chart-card';
import { mygooruAPI } from '@/providers/apis/mygooru/mygooru';
import DonutChartCard from './donut-card/donut-chart-card';
import { formatDuration, isAPICatchError } from '@/utils/utils';
import {
    COUNTRY, DEFAULT_IMAGES_PATH, DEFAULT_REPORT_IMAGES_PATH, GROUP_TYPES, INSIGHTS_FILTERS_TYPE,
    FEEDBACK_IDS,
    MONTHS, ReportDefaultColor, ReportTypeEnum,
    FEEDBACK_TYPES,
    frequencyTypes,
} from '@/utils/constants';
import BarChartCardComponent from './bar-chart-card/bar-chart-card';
import { appConfigService } from '@/providers/services/app/app-config';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import FiltersDropdown from './filters-dropdown/filters-dropdown';
import BarChartGroupedComponent from './stacked-bar-chart/stacked-bar-chart';
import { sessionService } from '@/providers/services/auth/session';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { groupsApi } from '@/providers/apis/groups/groups';
import { CountryData } from '@/models/groups/country';
import { GroupHierarchy } from '@/models/groups/hierarchy';
import UserReportCard from './user-reports-card/user-report-card';
import { UserLevelReportResponse } from '@/models/mygooru-reports/mygooru-reports';

@Component({
    name: 'mygooru-insights',
    components: {
        'month-picker': MonthYearPicker,
        'donut-chart-card': DonutChartCard,
        'chart-card': ChartCardComponent,
        'bar-chart-card': BarChartCardComponent,
        'material-icon': GoogleMaterialIcon,
        'dropdown': FiltersDropdown,
        'stacked-bar-chart': BarChartGroupedComponent,
        'user-report-card': UserReportCard,
    },

})

export default class Mygooru extends Vue {

    // -------------------------------------------------------------
    // Properties

    public activeCategory = 'highest';

    public userTypeColors: { [key: string]: string } = {
        Free: '#4b8fe2',
        Studend: '#2bcc8d',
    };

    public freequencyValue = [
        {
            name: 'Daily',
            key: 'daily',
        },
        {
            name: 'Weekly',
            key: 'weekly',
        },
    ];

    public engagementFilters = [
        {
            id: 1,
            name: 'Nudge View',
            key: 'nudge-view',
        },
        {
            id: 2,
            name: 'Date Range View',
            key: 'date-range-view',
        },
        // {
        //     id: 3,
        //     name: 'Category View',
        //     key: 'category-view',
        // },
    ];

    public filters: any = [
        {
            id: 1,
            name: 'User Type',
            key: 'userType',
            options: [],
        },
        {
            id: 2,
            name: 'Nudge Type',
            key: 'nudgeType',
            options: [
            ],
        },
        // {
        //     name: 'Subject',
        //     key: 'subject',
        //     options: [],
        // },
        // {
        //     name: 'Grade',
        //     key: 'grade',
        //     options: [],
        // },
        // {
        //     name: 'Geography',
        //     key: 'geography',
        //     options: [],
        // }
    ];

    public userType!: string;

    public nudgeId: string = '';

    public frequency: string = frequencyTypes.daily;

    public selectInteractionFilter: string = 'nudge-view';

    public nudgeFrequency: string = 'monthly';

    public nudgeInteractionFrequency: string = 'monthly';

    public activeUsersData: any = [];

    public avgSessionData: any = [];

    public nudgeTimeSpentData: any = [];

    public nudgeEngagementData: any = [];

    public nudgeFeedbackData: any = [];

    public nudgesList: any = [];

    public showAverageSessionChart: boolean = false;

    public showNudgeTimeSpentChart: boolean = false;

    public isDropdownOpen: boolean = false;

    public isLoading: boolean = false;

    public isPageLoading: boolean = false;

    public isNudgeTimeSpendLoading: boolean = false;

    public isNudgeInteractionLoading: boolean = false;

    public activeMonth: string = moment().date() === 1
        ? moment().subtract(1, 'month').format('MM')
        : moment().format('MM');

    public activeYear: string = moment().subtract(1, 'day').year().toString();

    public activeUserType!: string;

    public activeNudgeId: string = '';

    public activeNudgeInfo: any = {};

    public activeNudgeInteractionId: string = '';

    public activeNudgeInteractionInfo: any = {};

    public nudgeList: any = [];

    public activeTenant: any = null;

    public parentGroupName: string = '';

    public groupCountries: CountryData[] = [];

    public selectedGroupCountries: any = {};

    public groupHierarchies: any = [];

    public hierarchyId: number = 0;

    public groupId: number = 0;

    public groupType: string = '';

    public previousFilters: { [key: string]: any } = {};

    public selectedTenant: any = null;

    public activeUserLevelReport: UserLevelReportResponse = { totalCount: 0, reports: [] };

    public sessionTimeUserLevelReport: UserLevelReportResponse = { totalCount: 0, reports: [] };

    public nudgeUsageUserLevelReport: UserLevelReportResponse = { totalCount: 0, reports: [] };

    public nudgeInteractionUserLevelReport: UserLevelReportResponse = { totalCount: 0, reports: [] };

    public nudgeFeedbackUserLevelReport: any = { totalCount: 0, reports: [] };

    public userIds: string[] = [];

    public activeUsersPaginationOffset: number = 0;

    public sessionTimePaginationOffset: number = 0;

    public nudgeUsgaePageOffset: number = 0;

    public nudgeInteractionPageOffset: number = 0;

    public defaultLimit: number = 20;

    public activeUserReportSelectedPeriod: string = '';

    public sessionReportSelectedPeriod: string = '';

    public nudgeUsageReportSelectedPeriod: string = '';

    public nudgeInteractionReportSelectedPeriod: string = '';

    public nudgeReportSelectedPeriod: string = '';

    public nudgeInteractionSelectedPeriod: string = '';

    public selectNudgeUsageUserIds: string[] = [];

    public selectNudgeInteractionUserIds: string[] = [];

    public selectedActiveUserIds: string[] = [];

    public selectedSessionUsageUserIds: string[] = [];

    public isUserReportLoading: boolean = false;

    public isActiveUserReportLoading: boolean = false;

    public isSessionTimeReportLoading: boolean = false;

    public isNudgeUsageUserLevelReportLoading: boolean = false;

    public isNudgeInteractionUserLevelReportLoading: boolean = false;

    public isNudgeFeedbackUserLevelReportLoading: boolean = false;

    public activeFeedbackNudge: any = {};

    public defaultNudgeInteraction = {
        nudgeId: 'Did you know?',
        label: 'did-you-know',
        logo: `${this.cdnUrl}assets/web/my-gooru/new-did-you-know.svg`,
    };

    public get cdnUrl() {
        return appConfigService.getCdnUrl();
    }

    public get nudgeInfo() {
        return appConfigService.getNudgeInfo();
    }

    public get reportUserType() {
        return appConfigService.getReportUserType();
    }

    public get highestSessionTime(): Array<{ userType: string; mins: string, color: string }> {
        if (
            !this.avgSessionData ||
            !this.avgSessionData.overallStats ||
            !Array.isArray(this.avgSessionData.overallStats.avg_session_by_user_type)
        ) {
            return [];
        }
        const avgSessionByUserType = this.avgSessionData.overallStats.avg_session_by_user_type;

        if (avgSessionByUserType.length === 0) {
            return [];
        }
        const highestTimes: Array<{ userType: string; mins: string, color: string }> = [];
        if (avgSessionByUserType.length) {
            avgSessionByUserType.forEach((item: any) => {
                if (item.user_type && item.user_type !== 'undefined') {
                    const mins = formatDuration((item.avg_session_time_seconds.toString()));
                    const userTypeConfig = this.reportUserType[item.user_type];
                    highestTimes.push({
                        userType: item.user_type,
                        mins,
                        color: userTypeConfig ? userTypeConfig.line : ReportDefaultColor,
                    });
                }
            });
        }
        return highestTimes;
    }

    public get nudgeInteractionSummaryStats() {
        const stats = this.nudgeEngagementData.overallStats || {};
        return [
            { title: 'Total Nudges Recommended', count: stats.total_suggested_nudge_count || 0, color: 'light-blue' },
            { title: 'Total Nudges Accepted', count: stats.total_accepted_nudge_count || 0, color: 'yellow' },
            { title: 'Total Nudges Revisited', count: stats.total_revisit_nudge_count || 0, color: 'blue' },
        ];
    }

    public get activeTimeSpentCard() {
        const overallStats = this.nudgeTimeSpentData!.overallStats ||
            { highest_time_spend: [], lowest_time_spend: [] };

        const timeSpentData = this.activeCategory === 'highest'
            ? overallStats.highest_time_spend
            : overallStats.lowest_time_spend;

        return timeSpentData.map((item: any) => this.normalizeTimeSpend(item)) || [];
    }

    public get session() {
        return sessionService.getSession();
    }

    public get hasViewAllReportAccess() {
        return this.$access.hasPermission(this.$access.menus.mygooruInsights, this.$access.ACL.all);
    }

    // --------------------------------------------------------------
    // Hooks

    public async created() {
        this.isPageLoading = true;
        await Promise.all([
            this.loadHierarchyData(),
            this.fetchTenantNudge(),
            this.fetchTenantUserType(),
        ]);
        await this.loadData();
        this.isPageLoading = false;
    }

    public async loadData() {
        this.isUserReportLoading = true;
        this.isNudgeInteractionLoading = true;
        this.isNudgeTimeSpendLoading = true;
        this.isLoading = true;
        this.setNudgeInfo();
        this.setNudgeInteractionInfo();
        const query = this.buildQuery();
        const nudgeTimeSpentQuery = this.buildNudgeTimeSpentQuery();
        const nudgeFeedbackQuery = this.buildNudgeFeedbackQuery();
        Promise.all([
            mygooruAPI.fetchActiveUsersTrends(query),
            mygooruAPI.fetchAverageSession(query),
            mygooruAPI.fetchNudgeAverageTimeSpent(nudgeTimeSpentQuery),
            mygooruAPI.fetchNudgeInteractions(nudgeTimeSpentQuery),
            mygooruAPI.fetchNudgeFeedback(nudgeFeedbackQuery),
        ]).then((
            [
                activeUsersResponse,
                avgSessionResponse,
                nudgeTimeSpentResponse,
                nudgeEngagementResponse,
                nudgefeedbackResponse,
            ]) => {
            this.showAverageSessionChart = true;
            this.activeUsersData = activeUsersResponse;
            this.avgSessionData = avgSessionResponse;
            this.nudgeTimeSpentData = nudgeTimeSpentResponse;
            this.nudgeEngagementData = nudgeEngagementResponse;
            this.addGroupOptionsToFilter(nudgeEngagementResponse.drillDown);
            const nudgeFeedback = nudgefeedbackResponse!.coordinates
                .map((item: any) => this.normalizeNudgeFeedback(item))
                .filter((nudge: any) => nudge.nudgeId != null);
            this.nudgeFeedbackData = nudgeFeedback;
            this.loadFeedbackContentReport();
            this.showNudgeTimeSpentChart = true;
            this.isNudgeInteractionLoading = false;
            this.isNudgeTimeSpendLoading = false;
            this.isLoading = false;
            this.isUserReportLoading = false;
        }).catch(() => {
            this.activeUsersData = [];
            this.avgSessionData = [];
            this.nudgeTimeSpentData = [];
            this.nudgeEngagementData = [];
            this.nudgeFeedbackData = [];
        }).finally(() => {
            this.isNudgeInteractionLoading = false;
            this.isNudgeTimeSpendLoading = false;
            this.isLoading = false;
            this.isUserReportLoading = false;
        });
    }

    public onSelectFrequency(key: string) {
        this.isLoading = true;
        this.frequency = key;
        this.clearUserReportData();
        this.loadData();
    }

    public onSelectInteractionFilter(key: string) {
        this.selectInteractionFilter = key;
        if (key === 'nudge-view') {
            this.onClickNudgeInteractionBack();
        } else if (key === 'date-range-view') {
            this.onSelectNudgeInteraction(this.defaultNudgeInteraction);
        }
    }

    public formatAvgSessionDuration(value: any) {
        const min = formatDuration(value!.avg_session_time_seconds);
        const activeMonth = Number(this.activeMonth);
        const month = MONTHS[activeMonth - 1];
        return `${month} ${Number(value!.label)} for ${min}`;
    }

    public async fetchTenantNudge() {
        try {
            const tenantId = this.session!.tenant!.tenant_id;
            const response = await tenantSettingsAPI.fetchTenantNudge(tenantId);
            const processedList = response.list
                .map((item: any) => ({
                    ...item,
                    name: item.title,
                    key: item.nudge_id,
                    icon: item.thumbnail!.icon
                        ? `${this.cdnUrl}${item.thumbnail.icon}`
                        : `${window.location.origin}${DEFAULT_IMAGES_PATH.assessment}`,
                }))
                .filter(
                    (item: any, index: number, self: any[]) =>
                        self.findIndex((data: any) => data.id === item.id && data.nudge_id === item.nudge_id) === index,
                );
            this.nudgeList = processedList;
            // Update Nudge Type filter options if applicable
            const nudgeTypeObject = this.filters.find((filter: any) => filter.key === INSIGHTS_FILTERS_TYPE.NudgeType);
            if (nudgeTypeObject) {
                nudgeTypeObject.options = processedList;
            }
        } catch {
            this.isLoading = false;
        }
    }

    public async fetchTenantUserType() {
        try {
            const response = await mygooruAPI.fetchTenantUserTypes();
            const processedUserTypes = response.userTypes.map((item: any) => ({
                name: item.type,
                key: item.id,
                color: this.reportUserType[item.type].line || ReportDefaultColor,
            })) || [];
            const userTypeFilter = this.filters.find((filter: any) => filter.key === INSIGHTS_FILTERS_TYPE.UserType);
            if (userTypeFilter) {
                userTypeFilter.options = processedUserTypes;
            }
        } catch (error) {
            this.isLoading = false;
        }
    }


    public buildQuery() {
        return {
            month: this.activeMonth,
            year: this.activeYear,
            frequency: this.frequency,
            ...(this.userType && { userType: this.userType }),
            ...(this.userIds.length > 0 && { userType: this.userIds }),
        };
    }

    public buildNudgeTimeSpentQuery() {
        return {
            month: this.activeMonth,
            year: this.activeYear,
            frequency: this.nudgeFrequency,
            ...(this.nudgeId && { nudgeId: this.nudgeId }),
            ...(this.userType && { userType: this.userType }),
            ...(this.groupId && { groupId: this.groupId }),
            ...(this.groupType && { groupType: this.groupType }),
        };
    }

    public buildNudgeFeedbackQuery() {
        return {
            month: this.activeMonth,
            year: this.activeYear,
            frequency: this.nudgeFrequency,
            ...(this.nudgeId && { nudgeId: this.nudgeId }),
            ...(this.userType && { userType: this.userType }),
        };
    }

    public onChageTimeline(date: any) {
        const newMonth = moment(date).format('MM');
        const newYear = moment(date).format('YYYY');
        if (this.activeMonth !== newMonth || this.activeYear !== newYear) {
            this.activeMonth = newMonth;
            this.activeYear = newYear;
            this.clearUserReportData();
            this.loadData();
        }
    }

    public toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    public switchCategory(category: any) {
        this.activeCategory = category;
    }

    public normalizeTimeSpend(value: any) {
        const nudgeInfo: any =
            this.nudgeList.find((item: any) => item.nudge_id === value.nudge_id) ||
            this.nudgeInfo[value.nudge_id] || {};
        const iconUrl = (nudgeInfo.thumbnail && nudgeInfo.thumbnail.icon) || nudgeInfo.icon || '';
        return {
            nudgeId: nudgeInfo!.name || value.nudge_id,
            timeSpent: formatDuration(value.avg_time_spent_seconds),
            logoUrl: `${this.cdnUrl}${iconUrl}`,
        };
    }

    public normalizeNudgeFeedback(value: any) {
        const nudgeInfo: any =
            this.nudgeList.find((item: any) => item.nudge_id === value.nudge_id) ||
            this.nudgeInfo[value.nudge_id] || {};
        const iconUrl = (nudgeInfo!.thumbnail && nudgeInfo!.thumbnail.icon) || nudgeInfo!.icon || '';
        return {
            nudgeName: nudgeInfo!.name || value.nudge_id,
            icon: `${this.cdnUrl}${iconUrl}`,
            likeCount: value.like_count,
            dislikeCount: value.dislike_count,
            nudgeId: value.nudge_id,
        };
    }

    public onNudgedSelect(nudge: any) {
        this.onSelectNudgeDate(nudge, true);
        this.isNudgeTimeSpendLoading = true;
        this.activeNudgeInfo = nudge;
        this.activeNudgeId = nudge.label;
        this.nudgeFrequency = this.frequency;
        this.fetchNudgeData();
    }

    public onSelectNudgeInteraction(nudge: any) {
        this.onSelectNudgeInteractionDate(nudge, true);
        this.nudgeInteractionFrequency = this.frequency;
        this.isNudgeInteractionLoading = true;
        this.selectInteractionFilter = 'date-range-view';
        this.activeNudgeInteractionInfo = nudge;
        this.activeNudgeInteractionId = nudge.label;
        this.fetchNudgeInteactionData();
    }

    public setNudgeInfo() {
        this.activeNudgeInfo = null;
        this.activeNudgeId = '';
        this.nudgeFrequency = 'monthly';
        this.nudgeUsageUserLevelReport = this.defaultUserLevelData();
    }

    public setNudgeInteractionInfo() {
        this.activeNudgeInteractionInfo = null;
        this.activeNudgeInteractionId = '';
        this.nudgeInteractionFrequency = 'monthly';
    }

    public onClickNudgeBack() {
        this.selectNudgeUsageUserIds = [];
        this.isNudgeTimeSpendLoading = true;
        this.setNudgeInfo();
        this.fetchNudgeData();
    }

    public onClickNudgeInteractionBack() {
        this.selectNudgeInteractionUserIds = [];
        this.selectInteractionFilter = 'nudge-view';
        this.isNudgeInteractionLoading = true;
        this.nudgeInteractionUserLevelReport = this.defaultUserLevelData();
        this.setNudgeInteractionInfo();
        this.fetchNudgeInteactionData();
    }

    public async fetchNudgeData() {
        const param = {
            month: this.activeMonth,
            year: this.activeYear,
            frequency: this.nudgeFrequency,
            ...(this.activeNudgeId && { nudgeId: this.activeNudgeId }),
            ...(this.groupId && { groupId: this.groupId }),
            ...(this.groupType && { groupType: this.groupType }),
            ...(this.userType && { userType: this.userType }),
            ...(this.selectNudgeUsageUserIds.length > 0 && { userIds: this.selectNudgeUsageUserIds.join(',') }),
        };
        await this.fetchNudgeUsageReport(param);
    }

    public async fetchNudgeUsageReport(param: any) {
        try {
            const response = await mygooruAPI.fetchNudgeAverageTimeSpent(param);
            this.nudgeTimeSpentData = response;
        } catch (error) {
            this.nudgeTimeSpentData = [];
        } finally {
            this.isNudgeTimeSpendLoading = false;
        }
    }

    public async fetchNudgeInteactionData() {
        const param = {
            month: this.activeMonth,
            year: this.activeYear,
            frequency: this.nudgeInteractionFrequency,
            ...(this.activeNudgeInteractionId && { nudgeId: this.activeNudgeInteractionId }),
            ...(this.groupId && { groupId: this.groupId }),
            ...(this.groupType && { groupType: this.groupType }),
            ...(this.userType && { userType: this.userType }),
            ...(this.selectNudgeInteractionUserIds.length > 0
                && { userIds: this.selectNudgeInteractionUserIds.join(',') }),
        };
        await this.fetchNudgeInteractions(param);
    }

    public async fetchNudgeInteractions(param: any) {
        mygooruAPI.fetchNudgeInteractions(param).then((response: any) => {
            this.nudgeEngagementData = response;
            this.isNudgeInteractionLoading = false;
        }).catch(() => {
            this.nudgeEngagementData = [];
        }).finally(() => {
            this.isNudgeInteractionLoading = false;
        });
    }

    public onSelectFilters(value: any) {
        Object.keys(value).forEach((key) => {
            const currentFilter = value[key];
            const previousFilter = this.previousFilters[key];

            // Skip if the filter value has not changed
            if (JSON.stringify(currentFilter) === JSON.stringify(previousFilter)) {
                return;
            }

            // Update the previous filter
            this.previousFilters[key] = currentFilter;
            switch (key) {
                case INSIGHTS_FILTERS_TYPE.UserType:
                    this.userType = value[key].key;
                    this.loadData();
                    break;
                case INSIGHTS_FILTERS_TYPE.NudgeType:
                    this.nudgeId = value[key].key;
                    const nudgeInfo = this.nudgeInfo[value[key].key] || {};
                    const payload = {
                        label: value[key].key,
                        logo: `${this.cdnUrl}${nudgeInfo.icon || ''}`,
                        nudgeId: value[key].name,
                    };
                    this.onSelectNudgeInteraction(payload);
                    this.onNudgedSelect(payload);
                    break;
                default:
                    if (GROUP_TYPES.includes(value[key].type)) {
                        this.groupId = value[key].id;
                        this.groupType = value[key].type;
                        this.loadData();
                    }
                    break;
            }
        });
    }

    public clearFilter(value: any) {
        // Remove the cleared filter from previousFilters
        if (value in this.previousFilters) {
            delete this.previousFilters[value];
        }
        switch (value) {
            case INSIGHTS_FILTERS_TYPE.UserType:
                this.userType = '';
                this.loadData();
                break;
            case INSIGHTS_FILTERS_TYPE.NudgeType:
                this.nudgeId = '';
                this.onClickNudgeInteractionBack();
                this.onClickNudgeBack();
                break;
            default:
                const { name, id, type } = this.selectedGroupCountries;
                this.groupId = id;
                this.groupType = type;
                this.loadData();
                break;
        }
    }

    public async loadHierarchyData(): Promise<any> {
        try {
            this.isLoading = true;
            const [groupHierarchies, groupCountry] = await Promise.all([
                groupsApi.fetchUserHierarchies(),
                groupsApi.fetchGroupCountries(),
            ]);
            if (isAPICatchError(groupHierarchies) || isAPICatchError(groupCountry)) {
                this.isLoading = false;
            }
            if (groupCountry.data && groupHierarchies) {
                this.groupCountries = groupCountry.data;
                this.groupHierarchies = groupHierarchies;
                if (this.groupCountries.length > 0) {
                    this.selectedGroupCountries = this.groupCountries[0];
                    const { name, id, type } = this.selectedGroupCountries;
                    this.parentGroupName = name;
                    this.groupId = id;
                    this.groupType = type;
                }
                const defaultHierarchy = (groupHierarchies as GroupHierarchy[])[0];
                if (defaultHierarchy.levels) {
                    this.normalizeLevel(defaultHierarchy.levels);
                }
            }
            this.isLoading = false;
        } catch (error) {
            this.isLoading = false;
        }
    }


    public normalizeLevel(level: any) {
        const levelFilters = level
            .filter((item: any) => item.type !== COUNTRY)
            .map((item: any) => ({
                id: item.id,
                name: item.name,
                key: item.type,
            }));
        this.filters.push(...levelFilters);
    }

    public addGroupOptionsToFilter(value: any) {
        if (!value || !Array.isArray(value) || value.length === 0) {
            return;
        }
        const key = value[0].type;
        const groupObject = this.filters.find((item: any) => item.key === key);
        if (groupObject) {
            groupObject.options = value;
        }
        this.filters = [...this.filters];
    }

    public onSelectCountry(value: any) {
        const { name, id, type } = value;
        if (id === this.groupId && type === this.groupType) {
            return;
        }
        this.parentGroupName = name;
        this.groupId = id;
        this.groupType = type;
        this.loadData();
    }

    public async onClickChartReport(value: any, type: string) {
        const isActiveReport = type === ReportTypeEnum.ACTIVE_USERS;
        const reportKey = isActiveReport ? 'activeUserLevelReport' : 'sessionTimeUserLevelReport';
        const reportOffsetKey = isActiveReport ? 'activeUsersPaginationOffset' : 'sessionTimePaginationOffset';
        const selectedDateOrWeek = isActiveReport ? 'activeUserReportSelectedPeriod' : 'sessionReportSelectedPeriod';

        // Reset loading states and data
        this.isActiveUserReportLoading = isActiveReport;
        this.isSessionTimeReportLoading = !isActiveReport;
        this[reportOffsetKey] = 0;
        this[selectedDateOrWeek] = value.dateOrWeek;
        this[reportKey] = this.defaultUserLevelData();

        const params = {
            reportType: type,
            month: this.activeMonth,
            year: this.activeYear,
            ...(this.frequency === frequencyTypes.daily && { day: this[selectedDateOrWeek] }),
            ...(this.frequency === frequencyTypes.weekly && { week: this[selectedDateOrWeek] }),
            offset: isActiveReport ? this.activeUsersPaginationOffset : this.sessionTimePaginationOffset,
            limit: this.defaultLimit,
        };
        try {
            const response = await this.fetchUserLevelReport(params);
            this[reportKey] = response || [];
            this.isActiveUserReportLoading = false;
        } catch (error) {
            this[reportKey] = this.defaultUserLevelData();
        } finally {
            this.isActiveUserReportLoading = false;
            this.isSessionTimeReportLoading = false;
        }
    }

    public onCloseSessionUserCard(type: string) {
        this.sessionTimeUserLevelReport = this.defaultUserLevelData();
        this.isActiveUserReportLoading = true;
    }

    public onCloseUserReport(type: string, userIds: string[]) {
        const reportMap: { [key: string]: () => void } = {
            [ReportTypeEnum.ACTIVE_USERS]: () => (this.activeUserLevelReport = this.defaultUserLevelData()),
            [ReportTypeEnum.SESSION_TIME]: () => (this.sessionTimeUserLevelReport = this.defaultUserLevelData()),
            [ReportTypeEnum.NUDGE_USAGE]: () => (this.nudgeUsageUserLevelReport = this.defaultUserLevelData()),
            [ReportTypeEnum.NUDGE_INTERACTION]: () =>
                (this.nudgeInteractionUserLevelReport = this.defaultUserLevelData()),
        };
        const resetReport = reportMap[type];
        if (resetReport) {
            resetReport();
        }
        this.onSelectUsers(userIds, type);
    }


    public async onSelectUsers(userIds: any, type: string) {
        if (type === ReportTypeEnum.ACTIVE_USERS) {
            this.selectedActiveUserIds = userIds;
            await this.fetchActiveUserReport();
        } else if (type === ReportTypeEnum.SESSION_TIME) {
            this.selectedSessionUsageUserIds = userIds;
            await this.fetchSessionTimeReport();
        } else if (type === ReportTypeEnum.NUDGE_USAGE) {
            this.selectNudgeUsageUserIds = userIds;
            await this.fetchNudgeData();
        } else if (type === ReportTypeEnum.NUDGE_INTERACTION) {
            this.selectNudgeInteractionUserIds = userIds;
            await this.fetchNudgeInteactionData();
        }
    }



    public async fetchUserLevelReport(params: any) {
        return await mygooruAPI.fetchUserLevelReport(params);
    }

    public async fetchActiveUserReport() {
        this.isUserReportLoading = true;
        try {
            const params = {
            month: this.activeMonth,
            year: this.activeYear,
            frequency: this.frequency,
            ...(this.selectedActiveUserIds.length > 0 && { userIds: this.selectedActiveUserIds.join(',') }),
            ...(this.userType && { userType: this.userType }),
        };
            const response = await mygooruAPI.fetchActiveUsersTrends(params);
            this.activeUsersData = response;
        } catch (error) {
            this.activeUsersData = [];
        } finally {
            this.isUserReportLoading = false;
        }
    }

    public async fetchSessionTimeReport() {
        this.isLoading = true;
        try {
            const params = {
            month: this.activeMonth,
            year: this.activeYear,
            frequency: this.frequency,
            ...(this.selectedSessionUsageUserIds.length > 0 && { userIds: this.selectedSessionUsageUserIds.join(',') }),
            ...(this.userType && { userType: this.userType }),
        };
            const response = await mygooruAPI.fetchAverageSession(params);
            this.avgSessionData = response;
        } catch (error) {
            this.avgSessionData = [];
        } finally {
            this.isLoading = false;
        }
    }

    public async onLoadMore(type: string, userIds: string[]) {
        let reportKey: any;
        let selectedDateOrWeek;
        let nudgeId;
        let offset = 0;
        if (type === ReportTypeEnum.ACTIVE_USERS) {
            reportKey = this.activeUserLevelReport;
            selectedDateOrWeek = this.activeUserReportSelectedPeriod;
            offset = this.activeUsersPaginationOffset += this.defaultLimit;
            this.isActiveUserReportLoading = true;
        } else if (type === ReportTypeEnum.SESSION_TIME) {
            reportKey = this.sessionTimeUserLevelReport;
            selectedDateOrWeek = this.sessionReportSelectedPeriod;
            offset = this.sessionTimePaginationOffset += this.defaultLimit;
            this.isSessionTimeReportLoading = true;
        } else if (type === ReportTypeEnum.NUDGE_USAGE) {
            reportKey = this.nudgeUsageUserLevelReport;
            selectedDateOrWeek = this.nudgeUsageReportSelectedPeriod;
            offset = this.nudgeUsgaePageOffset += this.defaultLimit;
            nudgeId = this.activeNudgeId;
            this.isNudgeUsageUserLevelReportLoading = true;
        } else if (type === ReportTypeEnum.NUDGE_INTERACTION) {
            reportKey = this.nudgeInteractionUserLevelReport;
            selectedDateOrWeek = this.nudgeInteractionReportSelectedPeriod;
            offset = this.nudgeInteractionPageOffset += this.defaultLimit;
            nudgeId = this.activeNudgeInteractionId;
            this.isNudgeInteractionUserLevelReportLoading = true;
        }

        const params = {
            reportType: type,
            ...(nudgeId && { nudgeId }),
            month: this.activeMonth,
            year: this.activeYear,
            ...(this.frequency === frequencyTypes.daily && selectedDateOrWeek && { day: selectedDateOrWeek }),
            ...(this.frequency === frequencyTypes.weekly && selectedDateOrWeek && { week: selectedDateOrWeek }),
            offset,
            limit: this.defaultLimit,
        };
        try {
            const response = await this.fetchUserLevelReport(params);
            reportKey!.reports = [...reportKey!.reports, ...response.reports];
        } catch (error) {
            reportKey = this.defaultUserLevelData();
        } finally {
            this.isActiveUserReportLoading = false;
            this.isSessionTimeReportLoading = false;
            this.isNudgeUsageUserLevelReportLoading = false;
            this.isNudgeInteractionUserLevelReportLoading = false;
        }
    }

    public async onSelectNudgeDate(data: any, isNudge = false) {
        this.isNudgeUsageUserLevelReportLoading = true;
        this.nudgeUsgaePageOffset = 0;
        this.nudgeUsageUserLevelReport = this.defaultUserLevelData();
        this.nudgeUsageReportSelectedPeriod = !isNudge ? data.dateOrWeek : '';
        const params = {
            reportType: ReportTypeEnum.NUDGE_USAGE,
            nudgeId: this.activeNudgeId || data.label,
            month: this.activeMonth,
            year: this.activeYear,
            offset: this.nudgeUsgaePageOffset,
            limit: this.defaultLimit,
            ...(this.frequency === frequencyTypes.daily && !isNudge && { day: data.dateOrWeek }),
            ...(this.frequency === frequencyTypes.weekly && !isNudge && { week: data.dateOrWeek }),
        };
        const response = await this.fetchUserLevelReport(params);
        this.nudgeUsageUserLevelReport = response || [];
        this.isNudgeUsageUserLevelReportLoading = false;
    }

    public async onSelectNudgeInteractionDate(data: any, isNudge = false) {
        this.isNudgeInteractionUserLevelReportLoading = true;
        this.nudgeInteractionPageOffset = 0;
        this.nudgeInteractionUserLevelReport = this.defaultUserLevelData();
        this.nudgeInteractionReportSelectedPeriod = !isNudge ? data.dateOrWeek : '';
        const params = {
            reportType: ReportTypeEnum.NUDGE_INTERACTION,
            nudgeId: this.activeNudgeInteractionId || data.label,
            month: this.activeMonth,
            ...(this.frequency === frequencyTypes.daily && !isNudge && { day: data.dateOrWeek }),
            ...(this.frequency === frequencyTypes.weekly && !isNudge && { week: data.dateOrWeek }),
            year: this.activeYear,
            offset: this.nudgeInteractionPageOffset,
            limit: this.defaultLimit,
        };
        const response = await this.fetchUserLevelReport(params);
        this.nudgeInteractionUserLevelReport = response || [];
        this.isNudgeInteractionUserLevelReportLoading = false;
    }

    public defaultUserLevelData() {
        return { totalCount: 0, reports: [] };
    }

    public clearUserReportData() {
        this.activeUserLevelReport = this.defaultUserLevelData();
        this.sessionTimeUserLevelReport = this.defaultUserLevelData();
        this.nudgeUsageUserLevelReport = this.defaultUserLevelData();
        this.nudgeInteractionUserLevelReport = this.defaultUserLevelData();
        this.nudgeFeedbackUserLevelReport = this.defaultUserLevelData();
        this.activeUserReportSelectedPeriod = '';
        this.sessionReportSelectedPeriod = '';
        this.nudgeUsageReportSelectedPeriod = '';
        this.nudgeInteractionReportSelectedPeriod = '';
        this.activeFeedbackNudge = {};
        this.activeUsersPaginationOffset = 0;
        this.sessionTimePaginationOffset = 0;
        this.nudgeUsgaePageOffset = 0;
        this.nudgeInteractionPageOffset = 0;
        this.selectNudgeUsageUserIds = [];
        this.selectNudgeInteractionUserIds = [];
        this.selectedActiveUserIds = [];
        this.selectedSessionUsageUserIds = [];
        this.userIds = [];
    }

    public async onClickFeedback(nudge: any, feedbackId: string) {
        this.isNudgeFeedbackUserLevelReportLoading = true;
        this.activeFeedbackNudge = { ...nudge, type: FEEDBACK_IDS[feedbackId], feedbackId };
        const params = {
            reportType: ReportTypeEnum.NUDGE_FEEDBACK,
            nudgeId: nudge.nudgeId,
            month: this.activeMonth,
            year: this.activeYear,
            offset: this.nudgeUsgaePageOffset,
            limit: this.defaultLimit,
            feedbackId,
        };
        try {
            const response = await this.fetchUserLevelReport(params);
            this.nudgeFeedbackUserLevelReport.reports = response.reports.map((report: any) => ({
                ...report,
                users: report.users.map((item: any) => ({
                    ...item,
                    profile: this.getThumbnailUrl(item),
                    userName: item.first_name
                    ? `${item.first_name}${item.last_name ? ` ${item.last_name}` : ''}`
                    : item.username || item.email || item.display_name || '',
                })),
                isExpand: false,
            }));

        } catch (e) {
            this.nudgeFeedbackUserLevelReport = this.defaultUserLevelData();
        } finally {
            this.isNudgeFeedbackUserLevelReportLoading = false;
        }
    }

    public getThumbnailUrl(res: any): string {
        return res.thumbnail
            ? res.cdn_urls.user_cdn_url + res.thumbnail
            : window.location.origin +
            DEFAULT_REPORT_IMAGES_PATH[Math.floor(Math.random() * DEFAULT_REPORT_IMAGES_PATH.length)];
    }

    public normalizeTitle(title: string) {
        return title.replace(/<\/?[^>]+(>|$)/g, '').replace(/^["/]+|["/]+$/g, '');
    }

    public loadFeedbackContentReport() {
        const value = this.nudgeFeedbackData[0];
        if (!value) {
            return;
        }
        const feedbackId = value.likeCount && value.likeCount > 0
            ? FEEDBACK_TYPES.like
            : FEEDBACK_TYPES.dislike;
        const feedback = { ...value, type: FEEDBACK_IDS[feedbackId], feedbackId };
        this.onClickFeedback(feedback, feedbackId);
    }

    public toggleFeedbackCompExpand(index: number): void {
        const reports = this.nudgeFeedbackUserLevelReport.reports;
        if (reports[index]) {
            reports[index].isExpand = !reports[index].isExpand;
        }
    }

    public onClickTotalActiveUsers() {
        this.onClickChartReport({}, ReportTypeEnum.ACTIVE_USERS);
    }
}
